import { render, staticRenderFns } from "./ManageStoreTyoriSetting.vue?vue&type=template&id=39fc7f3f&"
import script from "./ManageStoreTyoriSetting.vue?vue&type=script&lang=js&"
export * from "./ManageStoreTyoriSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports